<script>
import WebLinkMixin from '@/mixins/weblink'
import IconPlay from '@/components/IconPlay.vue'
import vueSignature from 'vue-signature'

import { SELLING_REGIONS, OPPORTUNITY_TYPES_IDS } from '@/constants'

// isMenuToggle: toggleMenu()
// isModalToggle: toggleModal()
// showCover: toggleCover()

export default {
  name: 'WebLinkTtcGroups',
  mixins: [ WebLinkMixin ],
  data () {
    return {
      isModalTermsAndConditionsToggle: false,
      isModalWhoWeAreVideoToggle: false,
      isModalTravelStylesVideoToggle: false,
      isModalTreadrightVideoToggle: false,
      isModalBookMyGroupSuccessToggle: false,
      isModalBookMyGroupToggle: false,
      modal: 0,
      signatureBoolean: true,
      signatureName: false,
      signaturePayment: false,
      signatureCondition: false,
      signatureNumber: false,
      signatureBox: false,
      constants: {
        SELLING_REGIONS,
        OPPORTUNITY_TYPES_IDS
      }
    }
  },
  methods: {
    toggleTermsAndConditionsModal (i = 0) {
      this.modal = i === 1 ? 1 : 0
      this.isModalTermsAndConditionsToggle = !this
        .isModalTermsAndConditionsToggle
      document.body.classList.toggle(
        'modal-open',
        this.isModalTermsAndConditionsToggle
      )
      if (this.modal === 1) {
        this.toggleBookMyGroupModal()
      }

      this.checkTermConditionScroll(this.isModalTermsAndConditionsToggle)
    },
    toggleWhoWeAreVideoModal () {
      this.isModalWhoWeAreVideoToggle = !this.isModalWhoWeAreVideoToggle
      document.body.classList.toggle('modal-open', this.isModalWhoWeAreVideoToggle)
    },
    toggleTravelStylesVideoModal () {
      this.isModalTravelStylesVideoToggle = !this.isModalTravelStylesVideoToggle
      document.body.classList.toggle('modal-open', this.isModalTravelStylesVideoToggle)
    },
    toggleTreadrightVideoModal () {
      this.isModalTreadrightVideoToggle = !this.isModalTreadrightVideoToggle
      document.body.classList.toggle('modal-open', this.isModalTreadrightVideoToggle)
    },
    toggleBookMyGroupModal () {
      this.isModalBookMyGroupToggle = !this.isModalBookMyGroupToggle
      document.body.classList.toggle(
        'modal-open',
        this.isModalBookMyGroupToggle
      )

      setTimeout(() => {
        let canvas = document.querySelector('.signature-gold canvas')
        if (canvas) {
          let parentWidth = canvas.parentElement.offsetWidth
          let parentHeight = canvas.parentElement.offsetHeight
          canvas.height = parentHeight
          canvas.width = parentWidth
        }
      }, 500)
    },
    toggleBookMyGroupSuccessModal () {
      this.isModalBookMyGroupSuccessToggle = !this
        .isModalBookMyGroupSuccessToggle
      document.body.classList.toggle(
        'modal-open',
        this.isModalBookMyGroupSuccessToggle
      )
    },
    muted () {
      var video = document.getElementById('videoLoop')
      video.muted = true
    },
    scrollMeTo (refName) {
      var element = document.getElementById(refName)
      window.scrollTo({
        top: element.offsetTop - 80,
        behavior: 'smooth'
      })
    },
    scrollMeDay (dd) {
      var element = document.getElementById(dd)
      var modal = document.getElementById('modal-fullscreen')
      modal.scrollTo({
        top: element.offsetTop,
        behavior: 'smooth'
      })
    },
    handleSaveSignature () {
      this.signatureName = false
      this.signaturePayment = false
      this.signatureCondition = false
      this.signatureNumber = false
      this.signatureBox = false
      if (
        this.signature.accepted_conditions === false ||
        this.signature.name === '' ||
        this.signature.payment_amount === '' ||
        this.signature.number_of_guests === ''
      ) {
        this.message = 'All the fields are required.'
        if (this.signature.accepted_conditions === false) {
          this.signatureCondition = true
        }
        if (this.signature.name === '') {
          this.signatureName = true
        }
        if (this.signature.payment_amount === '') {
          this.signaturePayment = true
        }
        if (this.signature.number_of_guests === '') {
          this.signatureNumber = true
        }
        return false
      }
      if (this.$refs.signature.isEmpty()) {
        this.message = 'Please fill your signature.'
        this.signatureBox = true
        return false
      }
      this.signature.uuid = this.$route.params.uuid
      this.signature.accepted_conditions = 1
      this.signature.image = this.$refs.signature.save()
      this.disableButton = true
      this.message = null
      this.sendSignature(this.signature)
        .then(response => {
          if (response.data && response.status === 200 && response.data.status) {
            this.cleanForm()
            this.disableButton = true
            this.hasSignature = true
            this.toggleBookMyGroupSuccessModal()
            this.toggleBookMyGroupModal()
          } else {
            this.message = 'Something went wrong, please try again.'
            this.isSending = false
            this.isCompleted = true
            this.disableButton = false
          }
        })
        .catch(error => {
          const hasMessage = error && error.response && error.response.data && error.response.data.message
          this.message = hasMessage || 'Something went wrong, please try again.'
          this.isSending = false
          this.isCompleted = true
          if (error.response.data.hash) {
            this.hash = error.response.data.hash
          }
          this.disableButton = false
        })
        .finally(() => {})
    },
    clear () {
      var _this = this
      _this.$refs.signature.clear()
    },
    undo () {
      var _this = this
      _this.$refs.signature.undo()
    },
    cleanForm () {
      this.signature.id = null
      this.signature.parent = null
      this.signature.name = ''
      this.signature.last_name = ''
      this.signature.user_agent = ''
      this.signature.payment_amount = ''
      this.signature.traveler_email = ''
      this.signature.number_of_guests = ''
      this.signature.accepted_conditions = 0
      this.signature.image = ''
      this.clear()
    },
    handleInput (e, value) {
      if (value !== '' || value) {
        e.target.classList.remove('active')
      }
    }
  },
  components: {
    IconPlay,
    vueSignature
  },
  mounted () {
    // this.signature.traveler_email = this.data.data.email_owner
    //   ? this.data.data.email_owner
    //   : ''
    this.signature.parent = this.data.data.itineraries.id
      ? this.data.data.itineraries.id
      : ''

    this.getSignature(this.signature.parent)
  }
}

</script>

<style lang="scss" scoped>
@import './font-fontawesome.scss';
@import './bootstrap.scss';
@import './main.scss';
@import './style-1.scss';
</style>
<template>
  <div id="menu" class="body-page fp-viewing-home body" :class="{ 'modal-open': isModalToggle }">
    <!-- BEGIN OF site header Menu -->
    <header class="page-header navbar page-header-drawer menu-right logo-left topmenu-right animated slow fadeIn hidePlease">

      <!-- Begin of menu icon toggler -->
      <button class="navbar-toggler site-menu-icon" id="navMenuIcon" :class="{ 'menu-visible': isMenuToggle }" @click="toggleMenu" v-if="showCover">
        <span class="menu-icon menu-icon-line" :class="{ 'menu-visible': isMenuToggle }">
          <span class="bars">
            <span class="bar1"></span>
            <span class="bar2"></span>
            <span class="bar3"></span>
          </span>
        </span>
      </button>

      <div class="cover-title" v-show="!showCover">
        <div class="cover-logo">
          <a class="navbar-brand" href="#">
            <span class="logo">
              <img class="light-logo" src="/weblinks/ttc-groups/img/logo.png" alt="Logo">
            </span>
          </a>
        </div>
      </div>

      <div class="all-menu-wrapper" id="navbarMenu" :class="{ 'menu-visible': isMenuToggle }">
        <nav class="navbar-mainmenu">
          <div class="mainmenu-bg" @click="toggleMenu"></div>
          <div class="mainmenu-content">
          <img src="/weblinks/ttc-groups/img/logo.png" alt="Logo" class="light-logo menu-logo">
          <div class="divider-menu">
          </div>
            <ul class="navbar-nav">
              <li class="nav-item">
                <a class="nav-link" href="#home" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('home')">Home
                  <span class="sr-only">(current)</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#map" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('map')">Map</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#itinerary" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('itinerary')">Itinerary</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#prices" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('prices')">Pricing</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#highlight" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('highlight')">Highlights</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#book" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('book')">Book my group</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#contact" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('contact')">Contact Us</a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </header>
    <!-- END OF site header Menu-->

    <!-- BEGIN OF page main content -->
    <main class="page-main main-anim scrollpage-container" id="mainpage">
      <div
        id="home"
        class="backgroundHome section section-home fullscreen-md main-home section-center content-black bg-level-1"
        data-section="home"
        :style="[firstOpporunityBackgroundImage != '' ? { backgroundImage: `url('${getParsedImageUrl(firstOpporunityBackgroundImage)}')`} : {'background-image': 'url(/weblinks/ttc-groups/img/bg-style-1.jpg)'}]">

        <div class="fullscreen-video-wrap" v-if="!showCover">
          <button class="button button-play button-play-two" type="button" id="firstPlayVideo" @click="playVideo"></button>
          <button type="button" class="btn btn-skip btn-link animated fadeIn slow" id="firstSkipVideo" @click="skipVideo"><div>Skip video <IconPlay/></div></button>
          <video
            allow='autoplay'
            preload="auto"
            playsinline
            id="videoLoop"
            class="animated fadeIn videoDesktop"
            poster="/weblinks/ttc-groups/video/video.jpg">
            <source src="https://itereo-prod.s3.us-east-2.amazonaws.com/weblink/ttc-groups/video/video.mp4" type="video/mp4"></video>
        </div>
        <div class="overlay-home" v-if="showCover"></div>
        <div class="section-wrapper animated delay-1s slow fadeIn home-flex">
          <div class="section-content anim">
            <div class="row">
              <div class="col-12 col-md-12 text-left">

                <div class="cover-header-description text-center" v-show="showCover">
                  <div class="location" v-if="Array.isArray(d.itineraries.locations_visited) == true">
                    <i class="fa fa-map-marker" ></i>
                    <span v-if="d && d.itineraries && d.itineraries.locations_visited && Array.isArray(d.itineraries.locations_visited)">{{ d.itineraries.locations_visited | custom-join('name') }}</span>
                  </div>
                  <div class="cover-slider-description">
                    <h1 class="cover-header-description-title1">
                      <i class="icon fa fa-calendar"></i>
                      <span class="text-uppercase" v-if="d && d.itineraries">{{ d.itineraries.fromitinerary | custom-date }}</span>
                      <i class="fa fa-arrow-right ml-2"></i>
                      <i class="icon fa fa-calendar"></i>
                      <span class="text-uppercase" v-if="d && d.itineraries">{{ d.itineraries.toitinerary | custom-date }}</span>
                    </h1>
                    <div class="cover-header-description-title2" v-if="d && d.itineraries">
                      {{ d.itineraries.titleitinerary }}
                    </div>
                    <div class="cover-header-description-title3">
                      <span class="oppor_type" v-if="d && d.properties_opportunity && d.properties_opportunity.id_opportunity_export_type">
                        <span v-if="d.properties_opportunity.id_opportunity_export_type === 2">Scheduled Groups</span>
                        <span v-if="d.properties_opportunity.id_opportunity_export_type === 18">Custom Group Quotation</span>
                      </span>
                      <span class="txt-uppercase" v-if="d && d.properties_opportunity && d.reference_number">
                        {{ d.reference_number }}
                      </span>
                    </div>
                  </div>
                </div>
                <div v-show="!showCover" class="text-center animated fadeInDown slow">
                  <div class="cover-header-description-title2 title-cover animated zoomIn slow delay-1s hidePlease" v-if="d && d.itineraries">
                    {{ d.itineraries.titleitinerary }}
                  </div>
                  <button id="submit-email" name="submit_email" class="btn btn-radius btn-red mb-0 hidePlease" @click="toggleCover">Explore Now
                  </button>
                </div>
              </div>

            </div>
          </div>

          <footer class="section-footer scrolldown" v-show="showCover">
            <a class="down" @click="scrollMeTo('letter')">
              <span class="icon"></span>
              <span class="txt">LETTER</span>
            </a>
          </footer>
        </div>
      </div>

      <!-- Begin of grid list section -->
      <div class="section fl-porto bg-level-1" data-section="letter" id="letter" v-show="showCover">
        <div class="section-wrapper with-margin">
          <div class="row">
            <div class="col-12 col-md-12">
              <div class="section-tittle text-center">
                <img class="ttcimage" src="/weblinks/ttc-groups/img/ttc_welcome.jpg">
                <div class="ttcwelcome">WELCOME TO <span>TTC</span></div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-12 text-left ">
              <!-- title and description -->
              <div
                class="title-desc anim-4 paddig-container letter-information"
                v-html="d.itineraries.letter_itinerary">
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End of grid list section -->

      <!-- Begin of grid list section -->
      <div class="section bg-level-2" data-section="itinerary" id="itinerary" v-show="showCover">
        <div class="section-wrapper with-margin">
          <div class="section-content anim paddig-container">
            <div class="section-tittle text-center">
              <div class="cover-header-description-title2 title-sections scrolled">Itinerary</div>
              <div class="cover-header-description-title3" v-if="d && d.itineraries">
                {{ d.itineraries.titleitinerary }}
              </div>
              <div class="cover-header-description-title4">
                <i class="icon fa fa-calendar"></i>
                <span class="text-uppercase" v-if="d && d.itineraries">{{ d.itineraries.fromitinerary | custom-date }}</span>
                <i class="fa fa-arrow-right"></i>
                <i class="icon fa fa-calendar"></i>
                <span class="text-uppercase" v-if="d && d.itineraries">{{ d.itineraries.toitinerary | custom-date }}</span>
                <i v-if="d && d.itineraries && d.itineraries.locations_visited && Array.isArray(d.itineraries.locations_visited)" class="fa fa-map-marker"></i>
                <span v-if="d && d.itineraries && d.itineraries.locations_visited && Array.isArray(d.itineraries.locations_visited)">{{ d.itineraries.locations_visited | custom-join('name') }}</span>
              </div>
            </div>
            <div class="row row-random grid-media-aside-text fade-3">

                <div class="col-md-4 border-card" v-for="(day, index) in d.itineraries.days" :key="index" @click="dayScrollTo(index)">
                  <div class="card gallery-day" data-toggle="modal" data-target="#modal-fullscreen">
                    <img v-if="day.url_image_1200_725" :src="day.url_image_1200_725"/>
                    <img v-if="!day.url_image_1200_725" src="/weblinks/ttc-groups/img/day-img.jpg"/>
                    <div class="info text-center">
                      <p class="day_position">day {{ day.startday }}</p>
                      <h1 class="title-day" v-html="day.title"></h1>
                      <p>
                        <i class="icon fa fa-calendar mr-2"></i>
                        <span class="text-uppercase" v-if="day">{{ day.startdate | custom-date }}</span>
                      </p>
                      <p v-if="day && day.locations && Array.isArray(day.locations)" class="location mt-2">
                        <i class="fa fa-map-marker mr-2"></i>
                        <span >{{ day.locations | custom-join('name') }}</span>
                      </p>
                    </div>
                  </div>
                </div>

            </div>
          </div>
        </div>
      </div>
      <!-- End of grid list section -->

      <!-- Begin of description section -->
      <!-- <div class="section fullscreen-md-off bg-level-3 no-footer bg-mark"
        data-section="highlight" id="highlight" v-show="showCover"> -->
      <div class="section fullscreen-md-off bg-level-3 bg-fixed" data-section="highlight" id="highlight" v-show="showCover"
        :style="[secondOpporunityBackgroundImage != '' ? { backgroundImage: `url('${getParsedImageUrl(secondOpporunityBackgroundImage)}')`} : {'background-image': 'url(/weblinks/ttc-groups/img/bg-style-1.jpg)'}]"
      v-if="Array.isArray(d.itineraries.highlights) && d.itineraries.highlights.length > 0 ||
      Array.isArray(d.itineraries.whatsincluded) && d.itineraries.whatsincluded.length > 0 ||
      Array.isArray(d.itineraries.whatsnotincluded) && d.itineraries.whatsnotincluded.length > 0">
        <div class="section-wrapper bg-overlay with-margin">
          <div class="section-content anim paddig-container">
            <div class="row">
              <div class="col-12 col-md-12 text-left">

                <div class="section-info white"
                v-if="Array.isArray(d.itineraries.highlights) && d.itineraries.highlights.length > 0">
                  <h1 class="title-sections title-sections-blue">Highlights</h1>
                  <div v-for="highlight in d.itineraries.highlights" :key="highlight.id">
                    <h3 class="hideInclusionTitle" v-html="highlight.title"></h3>
                    <ul class="mb-4 mt-4">
                      <li v-for="item in highlight.items" :key="item.id" v-html="item.items"></li>
                    </ul>
                  </div>
                </div>

                <div class="section-info light-blue  pr-4"
                v-if="Array.isArray(d.itineraries.whatsincluded) && d.itineraries.whatsincluded.length > 0">
                  <h1 class="title-sections title-sections-blue">What's Included</h1>
                  <div v-for="whatsinc in d.itineraries.whatsincluded" :key="whatsinc.id">
                    <h3 class="hideInclusionTitle"  v-html="whatsinc.title"></h3>
                    <ul class="mb-4 mt-4">
                      <li v-for="item in whatsinc.items" :key="item.id" v-html="item.items"></li>
                    </ul>
                  </div>
                </div>

                <div
                  class="section-info white pr-4"
                  v-if="Array.isArray(d.itineraries.whatsnotincluded) && d.itineraries.whatsnotincluded.length > 0">
                  <h1 class="title-sections color-red">What's not included</h1>
                    <div v-for="whatsnotinc in d.itineraries.whatsnotincluded" :key="whatsnotinc.id">
                    <h3 class="hideInclusionTitle" v-html="whatsnotinc.title"></h3>
                    <ul class="mb-4 mt-4">
                      <li v-for="item in whatsnotinc.items" :key="item.id" v-html="item.items"></li>
                    </ul>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section section-register bg-level-1" data-section="map" id="map" v-show="showCover">
        <div class="section-wrapper with-margin pb-0">
          <div class="section-content anim paddig-container">
            <div class="row">
              <div class="col-12 col-md-12 text-center">
                <div class="title-desc">
                  <h2 class="title-sections-blue title-sections">Map</h2>
                  <p class="mb-5 mt-3">Map route is to be used as a guide for illustration purposes only, and does not represent the exact path taken.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
         <div class="col-12 col-md-12 p0">
          <div class="section-maps">
            <Map :locations="locationsVisited" />
          </div>
        </div>
      </div>
      <!-- Begin of description section -->
      <div class="section fullscreen-md-off bg-level-2 no-footer " data-section="prices" id="prices" v-show="showCover">
        <div class="section-wrapper with-margin">
          <div class="section-content anim paddig-container">
            <div class="row">
              <div class="col-12 col-md-12 text-left">
                <div class="title-desc">
                  <h2 class="display-5 anim-2 title-sections content-white">Pricing</h2>
                </div>
                <div class="section-info section-pricing white" v-html="d.itineraries.pricing_itinerary"
                :class="{'usa' : 244 == d.selling_regions[0].id,'all-regions' : 244 != d.selling_regions[0].id }"></div>
                <p class="terms">View <a href="#" @click.prevent="toggleTermsAndConditionsModal">Terms and Conditions.</a></p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Begin of Book your group section -->
      <div class="fullscreen-md-off bg-level-3 bg-center" data-section="book" id="book" v-show="showCover"
      :style="[firstOpporunityBackgroundImage != '' ? { backgroundImage: `url('${getParsedImageUrl(firstOpporunityBackgroundImage)}')`} : {'background-image': 'url(/weblinks/ttc-groups/img/bg-style-1.jpg)'}]">
        <div class="section py-5 section-wrapper bg-overlay with-margin">
          <div class="section-content py-5 paddig-container">
            <div class="row">
              <div class="col-12 col-md-6 anim contact-info ">
                <div class="section-tittle">
                  <div
                    class="cover-header-description-title2 scrolled text-center"
                  >Book my group
                  </div>
                </div>
                <div class="pt-4 text-center m-auto">
                  <button class="pt-4 text-center text-book-signature px-0"
                  :disabled="data.data.request_form.properties_request_form.id_stage_supplier !== 23"
                  >
                    <span class="text-book-disabled">
                    Not activated until Quote Complete
                    </span>
                    <span class="text-book-enabled"> If you are happy with our proposal and would like to go ahead please click here.</span>
                  </button>
                  <div
                    class="form-group form-success-gone mb-0 d-flex justify-content-center align-items-center"
                  >
                    <button
                      class="mt-3 btn btn-radius btn-blue button-book-signature"
                      type="submit"
                      @click.prevent="toggleBookMyGroupModal"
                      :disabled="data.data.request_form.properties_request_form.id_stage_supplier !== 23"
                    >
                      <strong class="text">Book this trip</strong>
                    </button>
                  </div>
                </div>
              </div>

              <div
                class="col-12 col-md-6 anim contact-info  fluid contact-border-left"
              >
                <div class="book-image-box">
                  <img
                    v-if="secondOpporunityBackgroundImage != ''"
                    :src="`${getParsedImageUrl(secondOpporunityBackgroundImage)}`"
                    alt=""
                  />
                  <img
                    v-else
                    src="/weblinks/ttc-groups/img/day-img.jpg"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Begin of contact section -->
      <div class="section fullscreen-md-off bg-level-1 no-footer " data-section="about" id="about" v-show="showCover">
        <div class="section-wrapper">
          <div>
            <div class="row">
              <div class="col-12 col-md-4 p0">
                  <div class="card gallery-day justify-content-center card-about" @click.prevent="toggleWhoWeAreVideoModal">
                    <div class="info-about">
                      <img src="/weblinks/ttc-groups/img/whoweare.jpg"/>
                      <div class="info text-center">
                        <h1 class="title-day text-center">WHO WE ARE</h1>
                        <button type="button" class="button button-play button-play-about"></button>
                      </div>
                    </div>
                  </div>
              </div>
              <div class="col-12 col-md-4 p0">
                  <div class="card gallery-day justify-content-center card-about" @click.prevent="toggleTravelStylesVideoModal">
                    <div class="info-about">
                      <img src="/weblinks/ttc-groups/img/travelstyles.jpg"/>
                      <div class="info text-center">
                        <h1 class="title-day text-center">TRAVEL STYLES</h1>
                        <button type="button" class="button button-play button-play-about"></button>
                      </div>
                    </div>
                  </div>
              </div>
              <div class="col-12 col-md-4 p0">
                  <div class="card gallery-day justify-content-center card-about" @click.prevent="toggleTreadrightVideoModal">
                    <div class="info-about">
                      <img src="/weblinks/ttc-groups/img/treadright.jpg"/>
                      <div class="info text-center">
                        <h1 class="title-day text-center">TREADRIGHT</h1>
                        <button type="button" class="button button-play button-play-about"></button>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Begin of contact section -->
      <div class="section section-contact bg-level-1 bg-mark " data-section="contact" id="contact"  v-show="showCover">
        <img v-if="thirdOpporunityBackgroundImage != ''" :src="`${getParsedImageUrl(thirdOpporunityBackgroundImage)}`" alt="">
        <img v-else src="/weblinks/ttc-groups/img/bg-style-1.jpg" alt="">

        <div class="section-wrapper with-margin">
          <div class="section-content paddig-container">
            <div class="row">
              <div class="col-12 col-md-6 anim contact-info contact-info-left ">
                <div class="title-desc">
                  <h2 class="title-sections-blue text-center title-sections">Contact us</h2>
                </div>
                 <div class="pt-4">
                   <h3 class="pt-4 text-center" v-if="!d.firstname_owner && !d.lastname_owner">
                   Contact your Travel Advisor or call
                    </h3>
                    <h3 class="pt-4 text-center"><span v-if="d.firstname_owner">{{ d.firstname_owner }}</span> <span v-if="d.lastname_owner"> {{ d.lastname_owner }}</span></h3>
                    <h3 class="pt-4 text-center title-sections-blue">
                      <strong v-if="d.itineraries.sellingregions[0].id == constants.SELLING_REGIONS.US.id">1-888-370-2736 Option {{ d.properties_opportunity.id_opportunity_export_type === constants.OPPORTUNITY_TYPES_IDS.SCHEDULED ? "1" : d.properties_opportunity.id_opportunity_export_type === constants.OPPORTUNITY_TYPES_IDS.CUSTOM ? "2" : "" }}</strong>
                      <strong v-else-if="d.itineraries.sellingregions[0].id == constants.SELLING_REGIONS.GB.id">+44 20 7620 8996</strong>
                      <strong v-else-if="d.itineraries.sellingregions[0].id == constants.SELLING_REGIONS.AU.id">1300 780 283</strong>
                      <strong v-else-if="d.itineraries.sellingregions[0].id == constants.SELLING_REGIONS.CA.id">1-800-346-2830</strong>
                      <strong v-else>1 888 680 1241</strong>
                    </h3>
                  </div>
              </div>

              <div class="col-12 col-md-6 anim contact-info contact-info-right fluid contact-border-left">
                  <div class="title-desc">
                    <h2 class="title-sections-blue text-center title-sections">Message Us Directly</h2>
                  </div>
                <div class="contact-us-box">
                  <form  class="form-box" @submit.prevent="sendContactForm">
                    <div class="form-group ">
                      <input class="form-control-white" type="text" required placeholder="Your Name." v-model="name" :disabled="isSending">
                    </div>
                    <div class="form-group ">
                      <input class="form-control-white" type="text" required placeholder="Your Email." v-model="email" :disabled="isSending">
                    </div>
                    <div class="form-group ">
                      <textarea class="form-control-white" type="text" required placeholder="How can we assist you with this group?" cols="10" rows="10" v-model="description" :disabled="isSending"></textarea>
                    </div>
                    <div class="form-group form-success-gone text-right mb-0 d-flex justify-content-center align-items-center">
                      <div v-if="isCompleted">{{ message }}</div>
                      <button class="btn btn-radius btn-blue" type="submit" :disabled="isSending">
                        <span class="text" v-if="!isSending">Send</span>
                        <span class="text" v-else>Sending</span>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <footer v-show="showCover">
        <div class="section-wrapper padding-footer">
          <div class="powered-by-text">
            Powered by<br>
            <img src="/weblinks/ttc-groups/img/logo-itp.png" width="80">
          </div>
          <div class="detail">All rights reserved: ©Global Encounters™ 1999 - {{new Date().getFullYear()}}</div>
        </div>
      </footer>

    </main>
    <!-- Modal Fullscreen -- WHO WE ARE -->
      <div
        class="modal modal-fullscreenTC fade"
        id="modal-who-we-are" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
        :class="{ 'show': isModalWhoWeAreVideoToggle }"
        :style="{ display: 'block', paddingRight: '16px' }"
        v-show="isModalWhoWeAreVideoToggle">
        <div class="section-header">
          <button
            type="button" class="close" data-dismiss="modal" aria-hidden="true"
            @click="toggleWhoWeAreVideoModal"><i class="fa fa-times"></i></button>
        </div>
        <div class="modal-dialog animated fadeIn">
          <div class="modal-content modal-video-content">
            <div class="modal-body">
              <div
                class="video-modal">
                <iframe width="100%" height="100%" src="https://www.youtube.com/embed/l-srUJ1GQXU" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    <!-- Modal Fullscreen -- TRAVEL STYLES -->
      <div
        class="modal modal-fullscreenTC fade"
        id="modal-travel-styles" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
        :class="{ 'show': isModalTravelStylesVideoToggle }"
        :style="{ display: 'block', paddingRight: '16px' }"
        v-show="isModalTravelStylesVideoToggle">
        <div class="section-header">
          <button
            type="button" class="close" data-dismiss="modal" aria-hidden="true"
            @click="toggleTravelStylesVideoModal"><i class="fa fa-times"></i></button>
        </div>
        <div class="modal-dialog animated fadeIn">
          <div class="modal-content modal-video-content">
            <div class="modal-body">
              <div
                class="video-modal">
                <iframe width="100%" height="100%" src="https://www.youtube.com/embed/X7t9tZXgWO4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    <!-- Modal Fullscreen -- TREADRIGHT -->
      <div
        class="modal modal-fullscreenTC fade"
        id="modal-treadright" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
        :class="{ 'show': isModalTreadrightVideoToggle }"
        :style="{ display: 'block', paddingRight: '16px' }"
        v-show="isModalTreadrightVideoToggle">
        <div class="section-header">
          <button
            type="button" class="close" data-dismiss="modal" aria-hidden="true"
            @click="toggleTreadrightVideoModal"><i class="fa fa-times"></i></button>
        </div>
        <div class="modal-dialog animated fadeIn">
          <div class="modal-content modal-video-content">
            <div class="modal-body">
              <div
                class="video-modal">
                <iframe width="100%" height="100%" src="https://www.youtube.com/embed/tJDwHFOIXDs" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    <!-- Modal Fullscreen -- TERMS AND CONDITIONS -->
      <div
        class="modal modal-fullscreenTC fade"
        id="modal-terms-and-conditions-fullscreen" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
        :class="{ 'show': isModalTermsAndConditionsToggle }"
        :style="{ display: 'block', paddingRight: '16px' }"
        v-show="isModalTermsAndConditionsToggle">
        <div class="section-header">
          <button
            type="button" class="close" data-dismiss="modal" aria-hidden="true"
            @click="toggleTermsAndConditionsModal"><i class="fa fa-times"></i></button>
        </div>
        <div class="modal-dialog animated fadeIn">
          <div class="modal-content  ">
            <div class="modal-body">
              <div class="title-desc "><h3 class="h2 title-sections-2 title-sections-blue pt-3">Terms and Conditions</h3></div>
              <div
                class="title-desc anim-4 paddig-container scrollable terms-information"
                @scroll="handleTCScroll"
                v-html="d.itineraries.terms_conditions">
              </div>
            </div>
          </div>
        </div>
      </div>
    <!-- Modal -- MODAL BOOK MY GROUP -->
    <div
      class="modal modal-fullscreenTC fade"
      id="modal-book-my-group"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      :class="{ show: isModalBookMyGroupToggle }"
      :style="{ display: 'block', paddingRight: '16px' }"
      v-show="isModalBookMyGroupToggle"
    >
      <div class="section-header">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-hidden="true"
          @click="toggleBookMyGroupModal"
        >
          <i class="fa fa-times"></i>
        </button>
      </div>
      <div class="modal-dialog animated fadeIn">
        <div class="modal-content  ">
          <div class="modal-body">
            <div class="title-desc">
              <h3 class="h2 title-sections-2 title-sections-blue pt-3">Book my group</h3>
            </div>
            <div
              v-if="hasSignature"
              class="mx-5 my-3 alert alert-success"
              role="alert"
            >
              Thank you for confirming this group with us. Please Contact Us if we can assist you further.
            </div>
            <div
              class="title-desc px-5"
            >
              <form
                @submit.prevent="handleSaveSignature"
                class="form-gold mt-4 px-5 py-0"
              >
                <div class="form-group">
                  <input
                    class="form-control-white"
                    type="text"
                    placeholder="Your Full Name"
                    v-model="signature.name"
                    :disabled="hasSignature"
                    :class="{ active: signatureName }"
                    @blur="handleInput($event, signature.name)"
                  />
                </div>
                <div class="form-group">
                  <input
                    class="form-control-white"
                    type="text"
                    placeholder="No. of seats + No. of TW & SG room type requested. E.g.: 16 pax, 7 Twins + 2 Singles"
                    v-model="signature.number_of_guests"
                    :disabled="hasSignature"
                    :class="{ active: signatureNumber }"
                    @blur="handleInput($event, signature.number_of_guests)"
                  />
                </div>
                <div class="form-group">
                  <input
                    class="form-control-white"
                    type="text"
                    placeholder="Deposit amount paid"
                    v-model="signature.payment_amount"
                    :disabled="hasSignature"
                    :class="{ active: signaturePayment }"
                    @blur="handleInput($event, signature.payment_amount)"
                  />
                </div>
                <div v-if="signature.user_agent === ''" :class="[ signatureBox ? 'signature-gold box-signature-div active' : 'signature-gold box-signature-div']">
                  <vueSignature
                    ref="signature"
                    :sigOption="option"
                    :w="'100%'"
                    :h="'200px'"
                  ></vueSignature>
                  <button @click="clear" class="button_clear">Clear</button>
                  <button @click="undo" class="button_undo">Undo</button>
                </div>
                <div v-else class="signature-gold">
                  <img
                    class="img-signature"
                    width="100%"
                    v-bind:src="signature.user_agent"
                  />
                </div>
                <p :class="['terms mt-2 mb-1', { active: signatureCondition }, termConditionsRead ? '' : 'disabled']" v-if="!hasSignature">
                  <input
                    type="checkbox"
                    v-model="signature.accepted_conditions"
                    name=""
                    @blur="handleInput($event, signature.accepted_conditions)"
                  />
                  Accept T&Cs
                  <a
                    href="#"
                    class="terms_conditions_book"
                    @click.prevent="toggleTermsAndConditionsModal(1)"
                    >click here</a
                  >
                </p>
                <p class="terms mt-2 hideTerms" v-else>
                  View
                  <a
                    href="#"
                    class="terms_conditions_book"
                    @click.prevent="toggleTermsAndConditionsModal(1)"
                    >Terms and Conditions</a
                  >
                </p>
                <div
                  class="form-group form-success-gone mb-3 d-flex justify-content-center align-items-center"
                >
                  <div v-if="message" class="mr-32 dangerMessage">{{ message }}</div>
                  <button
                    class="btn my-2 btn-radius btn-blue form-success-gone button-book-signature"
                    type="submit"
                    :disabled="disableButton"
                  >
                    <strong class="text">Confirm</strong>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Finish Modal -- MODAL BOOK MY GROUP -->

    <!-- Modal -- MODAL SUCCESS -->
    <div
      class="modal modal-fullscreenTC fade"
      id="modal-book-my-group-success"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      :class="{ show: isModalBookMyGroupSuccessToggle }"
      :style="{ display: 'block', paddingRight: '16px' }"
      v-show="isModalBookMyGroupSuccessToggle"
    >
      <div class="section-header">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-hidden="true"
          @click="toggleBookMyGroupSuccessModal"
        >
          <i class="fa fa-times"></i>
        </button>
      </div>
      <div class="modal-dialog animated fadeIn">
        <div class="modal-content  ">
          <div
            class="modal-body d-flex justify-content-center align-items-center"
          >
            <div class="title-desc">
              <img
                class="success-img pt-4"
                src="/weblinks/ttc-groups/img/success-img.png"
              />
              <h3 class="h2 title-sections-2 title-sections-blue mb-3">Success</h3>
              <div class="anim-4 text-center pb-4">
                <p>Your information was sent.</p>
                <p>A
                    <strong class="bold-book-popup">Group Specialist</strong>
                    will make contact with you to<br> re-confirm details by the end of the next business day.
                </p>
                <div
                  class="form-group form-success-gone mb-0 d-flex justify-content-center align-items-center"
                >
                  <button
                    class="my-2 btn btn-radius btn-blue form-success-gone mb-0"
                    type="submit"
                    @click="toggleBookMyGroupSuccessModal"
                  >
                    <strong class="text">¡Great!</strong>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Finish Modal -- MODAL SUCCESS -->

    <!-- Modal Fullscreen -- DAYS-->
    <div
      class="modal modal-fullscreen fade modalDays animated fadeIn"
      id="modal-fullscreen" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
      :class="{ 'show': isModalToggle }"
      :style="{ display: 'block', paddingRight: '16px' }"
      v-show="isModalToggle">
      <div class="section-header">
        <img class="light-logo" src="/weblinks/ttc-groups/img/logo.png" alt="Logo">
        <button
          type="button" class="close" data-dismiss="modal" aria-hidden="true"
          @click="toggleModal"><i class="fa fa-times"></i></button>
      </div>
      <div class="modal-dialog ">
        <div class="modal-content  ">
          <div class="modal-body">

            <div
              class="col-md-12 p-0 section-day p active"
              :id="`day${index}`"
              v-for="(day, index) in d.itineraries.days" :key="index">
              <div class="row">
                <div class="col-md-6 cover-image">
                  <img v-if="day.url_image_1600_900" :src="day.url_image_1600_900"/>
                  <img v-if="!day.url_image_1600_900" src="/weblinks/ttc-groups/img/day-img.jpg"/>
                </div>
                <div class="col-md-6 section-text pl-0">
                  <div class="align-vcenter text-center">
                    <h1>Day {{ index + 1}}</h1>
                    <p class="subtittle" v-html="day.title"></p>
                    <p class="date text-uppercase title-sections-blue fw-500">
                      <i class="icon fa fa-calendar mr-1"></i>
                      <span v-if="day">{{ day.startdate | custom-date }}</span>
                    </p>
                    <p class="location mt-2 text-uppercase title-sections-blue fw-500" v-if="day && day.locations && Array.isArray(day.locations)" >
                      <i class="fa fa-map-marker mr-2"></i>
                      <span>{{ day.locations | custom-join('name') }}</span>
                    </p>
                    <p class="day-information" v-if="day && day.textday && day.textday[0] && day.textday[0].textday" v-html="day.textday[0].textday"></p>
                    <p v-if="day.meals">
                      <strong class="mr-1">MEAL(S):</strong>
                      <span>{{ day.meals | custom-join('mealsday') }}</span>
                    </p>
                    <p v-if="day.accommodation">
                      <strong class="mr-1">ACCOMMODATION:</strong>
                      <span v-html="day.accommodation"></span>
                    </p>
                  </div>
                  <footer class="section-footer scrolldownDay nextday"
                  v-if="index != Object.keys(d.itineraries.days).length - 1">
                    <a class="down" @click="scrollMeDay(`day${index+1}`)">
                      <span class="txt">DAY {{ Number(day.startday) + 1 }}</span>
                    </a>
                  </footer>
                  <footer class="section-footer scrolldownDay nextday" v-else>
                    <a class="down" @click="scrollMeDay('day0')">
                      <span class="txt">DAY 1</span>
                    </a>
                  </footer>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>
